import { queryOptions, useQuery } from '@tanstack/react-query';

import { productsApi } from '../api/products-api';

import { productKeys } from './product-keys';

/** What the SKU rule would write for the product and each variant; `includeManual` also plans manual values. */
export function skuPreviewQueryOptions(productId: string, includeManual: boolean) {
  return queryOptions({
    queryKey: productKeys.skuPreview(productId, includeManual),
    queryFn: () => productsApi.skuPreview(productId, includeManual),
    // The plan depends on the counter and on other products' SKUs; always ask again when the dialog opens.
    staleTime: 0,
  });
}

export function useSkuPreview(productId: string, includeManual: boolean, enabled = true) {
  return useQuery({ ...skuPreviewQueryOptions(productId, includeManual), enabled });
}
